export const MENU_FILTER_LIST_SUCCESS = 'MENU_FILTER_LIST_SUCCESS';
export const RESTRICTION_INTERVAL_LIST_SUCCESS = 'RESTRICTION_INTERVAL_LIST_SUCCESS';
export const SET_DATE_RANGE_FILTER = 'SET_DATE_RANGE_FILTER';
export const SET_MENU_GUID_FILTER = 'SET_MENU_GUID_FILTER';
export const SET_SECTION_GUID_FILTER = 'SET_SECTION_GUID_FILTER';
export const SET_SALE_RATE_FILTER = 'SET_SALE_RATE_FILTER';
export const UNDO_CLEAR = 'UNDO_CLEAR';
export const UNDO_BUFFER_LENGTH_MODIFY = 'UNDO_BUFFER_LENGTH_MODIFY';
export const UNDO_POP = 'UNDO_POP';
export const UNDO_PUSH = 'UNDO_PUSH';
